export default {
  isMobile: state => state.isMobile,
  isExtraSmallMobile: state => state.isExtraSmallMobile,
  isAdhdFocusActive: state => state.isAdhdFocusActive
}
